import { useMemo } from 'react';
import { useUpdateSolutionViewerAccessMutation } from '../api';
/**
 * Hook to update a user's solution viewer access.
 *
 * @returns a mutation function to update solution viewer access.
 */
export const useUpdateSolutionViewerAccess = () => {
    const [updateSolutionViewerAccess, { isLoading, isError, error }] = useUpdateSolutionViewerAccessMutation();
    return useMemo(() => ({
        updateSolutionViewerAccess,
        isLoading,
        isError,
        error,
    }), [error, isError, isLoading, updateSolutionViewerAccess]);
};
